import React, { useRef, useEffect, useState } from "react";
import fruits from "../data/fruits";
import ProductCard from "./ProductCard";

const BestSellerFruits = () => {
  const scrollRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const scrollContainer = scrollRef.current;

    const scroll = () => {
      if (!isPaused && scrollContainer) {
        // keep scrolling slowly
        scrollContainer.scrollLeft += 1;

        // when reaching end, reset back smoothly
        if (
          scrollContainer.scrollLeft >=
          scrollContainer.scrollWidth - scrollContainer.clientWidth
        ) {
          scrollContainer.scrollLeft = 0;
        }
      }
    };

    const interval = setInterval(scroll, 20); // speed (lower = faster)
    return () => clearInterval(interval);
  }, [isPaused]);

  return (
    <div
      ref={scrollRef} // ✅ attach ref to the scrollable container
      style={{
        overflowX: "scroll",
        overflowY: "hidden",
        whiteSpace: "nowrap",
        position: "relative",
        marginTop: "20px",
        scrollbarWidth: "none", // hide scrollbar (Firefox)
        msOverflowStyle: "none", // hide scrollbar (IE/Edge)
      }}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
      <div
        style={{
          display: "flex",
          gap: "15px",
          flexWrap: "nowrap",
        }}
      >
        {/* Duplicate list for infinite loop */}
        {[...fruits, ...fruits].map((fruit) => (
          <div key={fruit.id + Math.random()} style={{ flex: "0 0 auto" }}>
            <ProductCard product={fruit} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default BestSellerFruits;
